import styled from 'styled-components';

export const MobileProfileCarouselStyled = styled.div`
    width: calc(100% + 32px);
    margin: 16px -16px 0;
    
    .slider-wrapper {
        padding: 0 12px;
    }
    
    .slide {
        padding: 0 4px;
    }
    
    .carousel-slider {
        overflow: unset;
        display: flex;
        flex-direction: column;
    }
    
    .control-dots {
        position: unset;
        bottom: -20px;
        margin: 0;
        order: 1;
        
        .dot {
            margin: 0 2px;
            width: 4px;
            height: 4px;
            border-radius: 2px;
            background: var(--icon-primary-color);
            opacity: unset;
            
            &.selected {
                width: 12px;
            }
        }
    }
`;
